const STATUS_STYLES = {
  "Available Soon": "text-[color:var(--brand-green)] bg-[color:var(--brand-green)]/10",
  "Coming Soon": "text-[color:var(--brand-orange)] bg-[color:var(--brand-orange)]/10",
  "Early Access": "text-[color:var(--brand-teal)] bg-[color:var(--brand-teal)]/10",
};

export default function StatusBadge({ status, className = "" }) {
  const style = STATUS_STYLES[status] || STATUS_STYLES["Coming Soon"];
  return (
    <span
      data-testid={`status-badge-${status.toLowerCase().replace(/\s+/g, "-")}`}
      className={`inline-flex items-center rounded-full px-2.5 py-1 text-[10px] font-semibold uppercase tracking-[0.14em] ${style} ${className}`}
    >
      <span className="mr-1.5 h-1.5 w-1.5 rounded-full bg-current opacity-70" />
      {status}
    </span>
  );
}
